import { Injectable } from '@angular/core';
import { BROWSER_TYPE } from '../../enum/browser';
import { WindowRefService } from '@core/services/helpers/window-ref.service';

@Injectable()
export class NavigatorRefService {
    private window: Window;

    constructor(private windowRefService: WindowRefService) {
        this.window = this.windowRefService.window;
    }

    get navigator(): Navigator {
        return this.window.navigator;
    }

    get browser(): BROWSER_TYPE {
        let type = BROWSER_TYPE.FIREFOX;

        if (this.navigator.vendor.toLowerCase().indexOf('apple') >= 0) {
            type = BROWSER_TYPE.SAFARI;
        } else if (this.navigator.vendor.toLowerCase().indexOf('google') >= 0) {
            type = BROWSER_TYPE.CHROME;
        }

        return type;
    }
}
